import React, { forwardRef } from 'react';

interface NotionInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  hint?: string;
  icon?: React.ReactNode;
}

export const NotionInput = forwardRef<HTMLInputElement, NotionInputProps>(
  ({ label, error, hint, icon, className = '', ...props }, ref) => {
    return (
      <div className="space-y-1.5">
        {label && (
          <label className="block text-sm font-medium text-[#37352F] dark:text-white">
            {label}
          </label>
        )}
        <div className="relative">
          {icon && (
            <div className="absolute left-3 top-1/2 -translate-y-1/2 text-[#787774] dark:text-gray-400">
              {icon}
            </div>
          )}
          <input
            ref={ref}
            className={`
              w-full px-3 py-2
              ${icon ? 'pl-10' : ''}
              bg-white dark:bg-gray-800
              border border-[rgba(55,53,47,0.16)] dark:border-gray-700
              rounded-md
              text-[#37352F] dark:text-white
              placeholder:text-[#787774] dark:placeholder:text-gray-500
              focus:outline-none focus:border-[#2383E2] focus:ring-2 focus:ring-[rgba(35,131,226,0.2)]
              disabled:opacity-50 disabled:cursor-not-allowed
              transition-colors
              ${error ? 'border-red-500 dark:border-red-500' : ''}
              ${className}
            `}
            {...props}
          />
        </div>
        {error && (
          <p className="text-sm text-red-600 dark:text-red-400">{error}</p>
        )}
        {hint && !error && (
          <p className="text-sm text-[#787774] dark:text-gray-400">{hint}</p>
        )}
      </div>
    );
  }
);

NotionInput.displayName = 'NotionInput';

export default NotionInput;
